import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import LogOutAllSessionsModal from '../components/LogOutAllSessionsModal';
import { toggleLogOutAllSessionsModalOpen } from '../actions/AppActions';
import { logoutAllSessions } from '../actions/ProfileActions';
import { getLogOutAllSessionsModalOpen } from '../selectors/InteractionSelector';
import { jsx as _jsx } from "react/jsx-runtime";
class LogOutAllSessionsModalContainer extends Component {
  render() {
    if (this.props.logOutAllSessionsModalOpen) {
      return /*#__PURE__*/_jsx(LogOutAllSessionsModal, {
        toggleLogOutAllSessionsModalOpen: this.props.toggleLogOutAllSessionsModalOpen,
        logoutAllSessions: this.props.logoutAllSessions
      });
    }
    return null;
  }
}
LogOutAllSessionsModalContainer.propTypes = {
  logOutAllSessionsModalOpen: PropTypes.bool.isRequired,
  toggleLogOutAllSessionsModalOpen: PropTypes.func.isRequired,
  logoutAllSessions: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    logOutAllSessionsModalOpen: getLogOutAllSessionsModalOpen(state)
  };
};
export default connect(mapStateToProps, {
  toggleLogOutAllSessionsModalOpen,
  logoutAllSessions
})(LogOutAllSessionsModalContainer);